module.exports = __webpack_public_path__ + "static/media/49_A.8b7c2598.png";